import { useEffect, useState } from "react";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "components/ui/dialog";

import { fetchAxiosToken } from "helpers/fetchAxiosToken";
import { toast } from "components/ui/use-toast";

import { ReloadIcon } from "@radix-ui/react-icons";

import dayjs from "dayjs";
import { Button } from "components/ui/button";

interface Props {
    setEdit: (visible: ScheduleBlocked | null) => void;
    edit: ScheduleBlocked;
    getEvents: () => void;
}

export interface ScheduleBlocked {
    id: string;
    start: string;
    end: string;
}

export const UpdateDateBlocked = ({ setEdit, edit, getEvents }: Props) => {
    const startDate = new Date(edit.start);
    const endDate = new Date(edit.end);

    const [lodingCanceling, setLoadingCanceling] = useState<boolean>(false);

    const cancelBlocked = async () => {
        if (edit === null) {
            return;
        }
        setLoadingCanceling(true);
        try {
            await fetchAxiosToken({
                url: `/horarios_no_disponibles/delete/${edit.id}`,
                method: "delete",
            });

            getEvents();
            toast({
                title: "Bloqueo cancelado correctamente",
            });
            setTimeout(() => {
                setLoadingCanceling(false);
            }, 2000);
            setEdit(null);
        } catch (error: any) {
            toast({
                variant: "destructive",
                title: "Error",
                description: <div>{error.response.data?.message}</div>,
            });
            setLoadingCanceling(false);
        }
    };

    return (
        <div className="absolute select-none">
            <Dialog defaultOpen={true} onOpenChange={() => setEdit(null)}>
                <DialogContent className="sm:max-w-[425px] select-none">
                    <DialogHeader>
                        <DialogTitle className="capitalize">
                            {" "}
                            {edit
                                ? ` ${dayjs(edit.start).format(
                                      "dddd"
                                  )} ${new Date(
                                      edit.start
                                  ).toLocaleDateString()}`
                                : ""}
                        </DialogTitle>
                        <DialogDescription>Fecha bloqueada</DialogDescription>
                    </DialogHeader>

                    <DialogFooter>
                        <Button
                            onClick={() => cancelBlocked()}
                            disabled={lodingCanceling}
                            type="button"
                            className="bg-red-400 select-none hover:bg-red-300">
                            {lodingCanceling ? (
                                <>
                                    <ReloadIcon className="w-4 h-4 mr-2 animate-spin" />
                                    Cargando
                                </>
                            ) : (
                                "Desbloquear fecha"
                            )}
                        </Button>
                    </DialogFooter>
                </DialogContent>
            </Dialog>
        </div>
    );
};
